<template>
  <b-radio :value="CATEGORY">
    <b-form inline>
      Display hollow bubbles when<br>
      <b-select
        v-model="categoryField"
        :options="fields"
        :disabled="!isCategory"
      /> <span class="mx-2">=</span>
      <b-select
        v-model="categoryValue"
        :options="valuesForCategoryField"
        :disabled="!isCategory || !categoryField"
      />
    </b-form>
  </b-radio>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import { HollowBubbleDisplays, Path } from '@/types'
import {
  HOLLOW_BUBBLES_CONFIG_KEY,
} from '@/constants'

const props = {
  display: {
    type: String,
    default: HollowBubbleDisplays.CATEGORY,
  },
}

@Component
export default class CategoryType extends Vue.extend({ props }) {
  CATEGORY = HollowBubbleDisplays.CATEGORY

  get fields () {
    return this.$typedStore.visualisationApp.stringFields
      .map(({ name, column }) => ({
        value: column,
        text: name,
      }))
  }

  get valuesForCategoryField () {
    const cutOff = 20
    if (this.categoryField && this.fields.find(({ value }) => value === this.categoryField)) {
      return this.$typedStore.visualisationData.fieldLeafDataUnique(Path.root, this.categoryField)
        .map(value => {
          let text = ''
          if (value && typeof value === 'string') {
            text = value.length > cutOff ? value.slice(0, cutOff) + '...' : value
          }

          return {
            value,
            text,
          }
        })
    } else {
      return []
    }
  }

  get isCategory () {
    return this.display === HollowBubbleDisplays.CATEGORY
  }

  get categoryField () {
    return this.$typedStore.primary.app.nestedConfig([HOLLOW_BUBBLES_CONFIG_KEY, 'categoryField'])
  }

  set categoryField (newValue) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [HOLLOW_BUBBLES_CONFIG_KEY, 'categoryField'],
      value: newValue,
    })
  }

  get categoryValue () {
    return this.$typedStore.primary.app.nestedConfig([HOLLOW_BUBBLES_CONFIG_KEY, 'categoryValue'])
  }

  set categoryValue (newValue) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [HOLLOW_BUBBLES_CONFIG_KEY, 'categoryValue'],
      value: newValue,
    })
  }
}

</script>
